import SmsInbox from "../models/SmsInbox";

const SmsInboxStore = SmsInbox.create();

export default SmsInboxStore;